/* eslint-disable jsx-a11y/alt-text */
import React, { useState, useEffect } from 'react';
import { Row, Col } from 'reactstrap';
import ReactTooltip from 'react-tooltip';
import styled from 'styled-components';

import counterPaths from './counterPaths';
import { IActiveUser } from '../../../globals/interfaces';
import { ProcessingAgentsMap } from './interfaces';
import apiClient from '../../../apiClient';

interface ActiveUserProps {
    user: IActiveUser;
    processingAgentsMap: ProcessingAgentsMap;
    showName: boolean;
    customWidth?: number;
    customColor?: string;
    darkMode?: boolean;
}

const ActiveUser = ({
    user,
    processingAgentsMap,
    showName,
    customWidth,
    customColor,
    darkMode,
}: ActiveUserProps) => {

    const pathParts = (user.path || '').split('/');
    const dataTip = `${(user.displayName || ' ').split(' ')[0]}, ${pathParts[pathParts.length - 1]
        }`;
    const onCounter = counterPaths[user.path];
    const color = (customColor !== undefined)
        ? customColor
        : user.online && onCounter && !processingAgentsMap[user.s_email]
            ? 'green'
            : user.online && (processingAgentsMap[user.s_email] || !onCounter)
                ? 'red'
                : 'grey';

    if (user) {
        return (
            <div className="d-inline pt-2" style={{ maxWidth: '56px' }}>
                <ReactTooltip />
                <Row data-tip={dataTip}>
                    {showName ? (
                        <>
                            <Col md={3}>
                                <div
                                    style={{
                                        ...styles.dot,
                                        backgroundColor: color,
                                    }}
                                ></div>
                            </Col>
                            <Col
                                md={9}
                                className={
                                    darkMode ? 'text-light' : 'text-dark'
                                }
                            >
                                {(user.displayName || ' ').split(' ')[0]}
                            </Col>
                        </>
                    ) : (
                        <Col md={12}>
                            <Photo
                                user={user}
                                color={color}
                                customWidth={customWidth}
                            />
                        </Col>
                    )}
                </Row>
            </div>
        );
    }

    return null;
};

const styles = {
    dot: {
        height: 10,
        width: 10,
        borderRadius: '50%',
    },
};

interface PhotoProps {
    user: IActiveUser;
    color: string;
    customWidth?: number;
}

const Photo = ({ user, color, customWidth }: PhotoProps) => {
    const [photo, setPhoto] = useState<string | null>(null);

    useEffect(() => {
        if (!user.s_email) return;

        let cancelled = false; // prevent race conditions

        const getUserPhoto = async () => {
            try {
                const res = await apiClient.get(`/user-data/${user.s_email}`);
                if (!cancelled) setPhoto(res.data.s_photo_link);
            } catch (err) { }
        };

        getUserPhoto();
        return () => { cancelled = true; };
    }, [user.s_email]); // ✅ re-fetches when the email actually changes

    return (
        <Container
            borderColor={color}
            customWidth={customWidth}
        >
            <Img
                src={
                    photo || require('../../../assets/img/head-side.jpg')
                }
                borderColor={color}
                customWidth={customWidth}
            />
        </Container>
    );
};

interface CssProps {
    borderColor: string;
    customWidth?: number;
}

const Container = styled.div<CssProps>`
    width: ${(p) => p.customWidth ? `${p.customWidth}px` : '75px'};
    height: ${(p) => p.customWidth ? `${p.customWidth}px` : '75px'};
    /* width: 75px;
    height: 75px; */
    border: 5px solid ${(p) => p.borderColor};
    border-radius: 50%;
    overflow: hidden;
`;

const Img = styled.img<CssProps>`
    max-width: 100%;
    max-height: 100%;
`;

const InitialContainer = styled.div<CssProps>`
    background-color: white;
    /* line-height: ${(p) => `${p.customWidth}px` || '75px'};
    font-size: 45px; */
    text-align: center;
`;

export default ActiveUser;
